import React, { useContext, useEffect, useCallback } from 'react';

import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import CaseSelect from 'components/UI/CaseSelect/CaseSelect';
import { UserDetailsContext } from 'context/userDetailsContext';
import { convertCaseToFilterFormat, toSelectValue } from 'utils/utils';

function CaseFilter() {
  const { fileManagerFilters, onFilterChange, isClientFileManager, setBreadCrumbs, setSelectedRows } = useFileManagerContext();
  const userContext = useContext(UserDetailsContext);

  const caseFilterValue = convertCaseToFilterFormat(userContext?.clientSelectedCase) || '';

  function clearBreadcrumbs() {
    setBreadCrumbs([]);
  }

  const handleFilterChange = useCallback(
    (selected) => {
      const value = selected ? { ...selected, id: selected.value ?? selected.case_id } : '';
      if (fileManagerFilters?.case !== value) {
        onFilterChange({ target: { name: 'case', value }, value }, clearBreadcrumbs);
        setSelectedRows([]);
      }
    },
    [fileManagerFilters?.case, onFilterChange, setSelectedRows]
  );

  useEffect(() => {
    // Only set the filter if:
    // 1. It's client file manager
    // 2. clientSelectedCase exists
    // 3. No case is currently selected in filters (to prevent overriding user selection)
    if (isClientFileManager && userContext?.clientSelectedCase && !fileManagerFilters?.case?.id) {
      onFilterChange(
        {
          target: {
            name: 'case',
            value: caseFilterValue,
          },
          value: caseFilterValue,
        },
        setBreadCrumbs
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userContext?.clientSelectedCase, isClientFileManager, fileManagerFilters?.case?.id]);

  return (
    <div className="filter-wraper">
      {isClientFileManager && userContext?.clientCaseList?.length > 1 && (
        <CaseSelect
          name="case"
          placeholder="Search case/lead..."
          value={toSelectValue(fileManagerFilters?.case)}
          onChange={handleFilterChange}
          isClearable={false}
        />
      )}
    </div>
  );
}

export default CaseFilter;
